import styled from "styled-components";
import {HomePageHeaderArenaRatioImageWrapperDefaultBox} from "./home-page-header-arena-ratio-image-wrapper.default.box";

export const HomePageHeaderArenaRatioImageWrapperCasino888Box = styled(HomePageHeaderArenaRatioImageWrapperDefaultBox)`
    max-width: 219px;
    margin: 0 auto;
`;